// Angular
import {Component, Input, OnInit} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {Yii} from "../../../../../libraries/interfaces/Yii";
import {ConfigFieldBuilderService} from "../config-field-builder.service";
import {HelperService} from "../../../services/helper.service";
import {BookingService} from "../../../../../libraries/service/booking/booking.service";
import {
    QUALITY_CHECK_ARRAY_FIELDS
} from "../config";
import {IFieldSpecs} from "../../../../../libraries/module/formbuilder/fields/interfaces/field-specs";
import {ApiResourceService} from "../../../../../libraries/service/apiResource/apiResource.service";
import {EnumsResourceService} from "../../../../../libraries/service/booking/enums/enums-resource.service";
import {
    ICheckboxGroupFieldConfig, IControl, IQualityCheckControl,
    IQualityCheckDictionary, IQualityCheckOperation, IQualityCheckControleInOperation
} from "../../../../../libraries/service/booking/IQualityCheck";

interface IFieldConfig {
    [name: string]: IFieldSpecs;
}

@Component({
    selector: 'quality-check-fieldset',
    template: `

        <div class="sep-top">
            <collapsible [title]="qualityCheckSearchTitle" [open]="open">
                <div class="sep-top">
                    <checkbox-group-field *ngIf="tabConfig?.length"
                                          [form]="form"
                                          [formattedQualityCheckList]="tabConfig"></checkbox-group-field>
                </div>
            </collapsible>
        </div>

    `
})
export class QualityCheckFieldsetComponent implements OnInit {

    @Input()
    public form: FormGroup;

    @Input()
    public open: boolean = true;

    public readonly qualityCheckSearchTitle: string = Yii.t('wui-sasha-js', 'Contrôle Qualité Afidium');
    public readonly testTranslation: string = Yii.t("wui-sasha-js", "je veux débloquer la traduction");
    public formFields: IFieldConfig;
    public tabConfig: ICheckboxGroupFieldConfig[] = [];

    constructor(
        private readonly configFieldBuilderService: ConfigFieldBuilderService,
        private readonly helperService: HelperService,
        private readonly bookingService: BookingService,
        private readonly apiResource: ApiResourceService,
        private readonly enumsResourceService: EnumsResourceService,
    ) {
    }

    public ngOnInit(): void {
        this.formFields = {...this.configFieldBuilderService.buildFieldConfigArray(this.form, QUALITY_CHECK_ARRAY_FIELDS)};
        this.initTabConfig();
    }

    private initTabConfig(): void {
        this.enumsResourceService.listQualityCheck()
            .subscribe((qualityCheckList: IQualityCheckDictionary): void => {
                qualityCheckList.qualityCheckOperationArray.forEach((operation: IQualityCheckOperation) => {
                    if (operation.qualityCheckControlArray.length) {
                        this.tabConfig.push({
                            operationCode: operation.code,
                            operationName: operation?.nameArray?.length ? operation.nameArray[0].value : operation.code,
                            controls: this.getControlPerOperation(qualityCheckList, operation),
                        });
                    }
                });
            });
    }

    private getControlPerOperation(qualityCheckList: IQualityCheckDictionary, operation: IQualityCheckOperation): IControl[] {
        return qualityCheckList.qualityCheckControlArray.filter((control: IQualityCheckControl) => {
                const mesControles = operation.qualityCheckControlArray.map((x: IQualityCheckControleInOperation) => x.code);
                return mesControles.includes(control.code);
            }
        ).map((controlItem: IQualityCheckControl) => {
            return {
                controlCode: controlItem.code,
                controlName: controlItem?.nameArray?.length ? controlItem.nameArray[0].value : controlItem.code
            }
        })
    }
}
